<template>
	<LayoutFormInputGeneral :inputId="inputId" :title="title" :subtitle="subtitle">
		<div class="input-group mb-3">
			<input type="text" :id="inputId" :value="proposal?.data?.url" class="form-control" :placeholder="placeholder" readonly>
			<button class="btn btn-neutral rounded-end" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-plus-lg"></i></button>
			<ul class="dropdown-menu dropdown-menu-end">
				<li >
					<a href="javascript:void(0);" class="dropdown-item vstack lh-xs" @click="copy">
						<div class="fw-bold">Copiar dirección</div>
						<small>Para pegarla donde quieras</small>
					</a>
				</li>
				<li v-for="(option, index) in options" v-bind:key="index">
					<a :href="option.href" target="_blank" class="dropdown-item vstack lh-xs">
						<div class="fw-bold">{{ option.title }}</div>
						<small v-html="option.subtitle"></small>
					</a>
				</li>
			</ul>
		</div>
	</LayoutFormInputGeneral>
</template>

<script>
	import { computed } from 'vue';
	import _ from 'lodash';
	import { useToast } from 'vue-toastification';
	import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

	export default {
		props: {
			proposal: Object,
			customer: Object,
			title: String,
			subtitle: String,
			placeholder: String
		},
		setup(props, { emit }) {
			const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;
			const toast = useToast();

			const options = computed(() => {
				let data = [];

				_.forEach(props.customer?.contacts?.phones ?? [], (phone) => {
					let phoneFormatted = null;
					phone = String(phone);

					if(isValidPhoneNumber(phone, props.customer?.company?.country_code)) phoneFormatted = parsePhoneNumber(phone, props.customer?.company?.country_code);
					else phoneFormatted = { number: phone, nationalNumber: phone };

					data.push({
						href: `https://wa.me/${phoneFormatted.number}?text=${encodeURIComponent(props.proposal?.data?.url)}`,
						title: `Enviar por whatsapp`,
						subtitle: `Al <b>${phoneFormatted.nationalNumber}</b>`
					});
				});

				_.forEach(props.customer?.contacts?.emails ?? [], (email) => {
					data.push({
						href: `mailto:${email}?body=${encodeURIComponent(props.proposal?.data?.url)}`,
						title: `Enviar por email`,
						subtitle: `A <b>${email}</b>`
					});
				});

				return data;
			});

			const copy = async () => {
				try {
					await navigator.clipboard.writeText(props.proposal?.data?.url);
					toast.success('¡Link copiado con éxito!');
				}catch {
					toast.error('Error al copiar link');
				}
			}

			return { inputId, copy, options };
		}
	}
</script>